// import something here
import axios from 'axios'
import { isNil, isObjectLike } from 'lodash'
import { addToCart } from 'dash/js/plugins/cart'
import saleStructure from 'dash/js/schemas/form.struct'

const baseUrl = '/api/v2/me/minhas-vendas'

export default class SalesHelper {

  static _deconstructAddress (payload) {
    const newAddress = {}

    Object.keys(payload).map(key => {
      let value = payload[key]

      switch (true) {
        case key === 'address':
          newAddress.name = value
          break

        case key === 'city':
          newAddress.city = value.city

          newAddress.state_abbr = value.state.state_abbr
          break

        default:
          newAddress[key] = value
          break
      }
    })

    return newAddress
  }

  /**
   * @param rootGetters
   * @param void
   */
  static _mergeSender (clients, sale) {
    const client = clients.find(item => item.id === sale.client_id)

    Object.keys(sale.sender).map(item => {
      if (isNil(sale.sender[item])) {
        sale.sender[item] = client[item]
      }

      if (isObjectLike(sale.sender[item])) {
        const address = this._deconstructAddress(client[item])

        Object.keys(sale.sender[item]).map(value => {
          if (isNil(sale.sender[item][value])) {
            sale.sender[item][value] = address[value]
          }
        })
      }
    })

    return sale
  }

  /**
   * @param  sales   This object is the same as state.requests | state.sales
   * @param  content The array with the sale or sales ID.
   * @return
   */
  static generatePromises (sales, content) {
    let payload = [];

    if (!Array.isArray(content)) {
      payload.push(content)
    }

    if (content.length > 1 || typeof content[0] === 'number') {
      sales.map((sale, index) => {
        if (content.indexOf(sale.id) !== -1) {
          payload.push(sale)
        }
      })
    }

    let promises = []

    // Check assyncronous: Must test with alot of sales selected.
    payload.forEach(async item => {
      promises.push(this.saleUpdate(item))
    })

    return promises
  }

  /**
   * @param {*} item
   */
  static async saleUpdate (item) {
    try {
      await axios.patch(`${baseUrl}/sales/${item.id}`, item)

      await addToCart(item)

      return item.id
    } catch (e) {
      if (e.hasOwnProperty('response') && e.response.hasOwnProperty('data') && e.response.data.hasOwnProperty('error')) {
        alert(e.response.data.error)
        return
      }

      alert('Ocorreu um erro')
    }
  }

  /**
   * @param {*} payload
   * @param {*} user
   * @param {*} callback
   */
  static verifySales (payload, getters, callback) {
    let { clients } = getters

    payload.data.map(async sale => {
      sale = this._mergeSender(clients, sale)

      sale = await this.calculate(sale)

      return Object.assign(saleStructure, sale)
    })

    callback(payload)
  }

  /**
   * @param {*} sale
   */
  static async calculate (sale) {
    return await axios.post(`${baseUrl}/sales/calculate`, sale).then(response => {
      return Object.assign(sale, response.data)
    })
  }

  /**
   * @param {*} sale
   * @param {*} callback
   */
  static validate (sale, callback) {
    axios.post(`${baseUrl}/sales/check`, sale).then(response => callback(response))
  }

  /**
   * Usada pelo checkbox master no header do Minhas Vendas. Responsável por atualizar o status do checkbox (true / false)
   *
   * @param {*} childrens
   * @param {*} sale
   * @param {*} status
   */
  static markCheckboxes (childrens, sale, status = true) {
    let identifier = `sale-checkbox-${sale}`

    let position = childrens.findIndex(child => child.$refs.hasOwnProperty(identifier))

    childrens[position].$refs[identifier].isChecked = status
  }
}
